import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map } from 'immutable';
import classNames from 'classnames';
import { DateTime } from 'src_common/utils/time/time';
import {
    TableWrapper,
    TableHeaderRow,
    TableRow,
    ColumnHeader,
    TableCell,
    SectionMessage,
    ChevronDownWrapper,
    CustomerTab,
    CustomerData,
    InnerTable
} from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/MatchedPaymentMethods.style';
import ActionsForm from 'src/components/FraudAndCompliance/ActionsForm/ActionsForm';
import {
    RowWithTable,
    TableRowAddColor,
} from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/MatchedAccount.style';
import { matchedPaymentMethods } from 'src_server/types';

const OPEN_BANKING_TYPE = 'open-banking';

const ACTIONS = {
    'your': [
        { id: 'cancel', name: 'Mark as reviewed' },
        { id: 'unassign', name: 'Unassign' }
    ],
    'none': [
        { id: 'assign', name: 'Assign to me' }
    ],
    'other': [
        { id: 'unassign', name: 'Unassign' }
    ]
};

class MatchedPaymentMethods extends React.Component {
    static propTypes = {
        type: PropTypes.string,
        status: PropTypes.string,
        className: PropTypes.string,
        onCancelRequest: PropTypes.func.isRequired,
        onAssignRequest: PropTypes.func.isRequired,
        onUnassignRequest: PropTypes.func.isRequired,
        onOpenAccountRequest: PropTypes.func.isRequired
    };

    static defaultProps = {
        className: ''
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            rows: []
        };
    }

    openAccount(id, name) {
        this.props.onOpenAccountRequest(id, name);
    }

    toggle(id) {
        const { rows } = this.state;

        return (e) => {
            e.preventDefault();
            var index = rows.indexOf(id);
            if (index > -1) {
                rows.splice(index, 1);
            } else {
                rows.push(id);
            }

            this.setState({
                rows
            });
        };
    }

    doAction(matchedPaymentMethod) {
        return (field, action) => {
            const { onCancelRequest, onAssignRequest,
                onUnassignRequest } = this.props;
            if (action === 'unassign') {
                onUnassignRequest(matchedPaymentMethod);
            } else if (action === 'assign') {
                onAssignRequest(matchedPaymentMethod);
            } else if (action === 'cancel') {
                onCancelRequest(matchedPaymentMethod);
            }
        };
    }

    renderRow(matchedPaymentMethod, rows, type) {
        const matchedPaymentJS = matchedPaymentMethod.toJS();

        const parsedResult = matchedPaymentMethods.matchedPaymentMethod.safeParse(matchedPaymentJS);
        if (parsedResult.success === false){
            console.error("MatchedPaymentMethod parsed error", parsedResult.error);
            return <div>Parse error</div>;
        }

        const { data } = parsedResult;
        const customerData = data.details.accounts?.find((account => account.id === data.accountId.toString()));

        return (
            <TableRow key={matchedPaymentMethod.get('id')} section={type} data-test={`matched-payment-row-${matchedPaymentMethod.get('id')}`}>
                <RowWithTable colSpan={9}>
                    <InnerTable>
                        <tbody>
                            <TableRowAddColor key={`${data.id}-row`}>
                                <TableCell>
                                    <ChevronDownWrapper
                                        onClick={this.toggle(data.id)}
                                        isCollapsed={rows.indexOf(data.id) === -1}
                                    />
                                </TableCell>
                                <TableCell>{ DateTime.from(data.createdAt).format('DD-MM-YYYY HH:mm') }</TableCell>
                                <TableCell>{ data.details.subtype === OPEN_BANKING_TYPE ? data.details.name : data.details.number }</TableCell>
                                <TableCell>{ data.details.subtype }</TableCell>
                                <TableCell>{ data.details.subtype === OPEN_BANKING_TYPE ? null : DateTime.from(data.details.expires).format('DD-MM-YYYY')}</TableCell>
                                <TableCell>{ data.details.accounts?.length ?? 0 }</TableCell>
                                <TableCell>{ customerData?.postcode ?? '' }</TableCell>
                                <TableCell>{ customerData?.email ?? '' }</TableCell>
                                <TableCell disableColor={true}>
                                    <ActionsForm
                                        onChange={ this.doAction(matchedPaymentMethod) }
                                        actions={ ACTIONS[type] }
                                    />
                                </TableCell>
                            </TableRowAddColor>

                            {rows.indexOf(data.id) === -1 ? null : (
                                <TableRowAddColor key={`${data.id}-row-expanded`} section='none' data-test={`matched-payment-row-expanded-${data.id}`} >
                                <td colSpan={9} className='table-row-opened'>
                                        {
                                            (data.details.accounts || []).map(
                                                account => {
                                                    const cls = classNames('customerTab', {
                                                        'customerTabBold': account.id === data.accountId.toString()
                                                    });
                                                    return (
                                                        <CustomerTab className={cls}
                                                            key={account.id}
                                                            onClick={(e) => this.openAccount(account.id, account.name)}>
                                                            <span className='status online'></span>
                                                            {account.name}
                                                            <CustomerData>
                                                            <span className='customerId'>{account.id}</span>
                                                            <span className='customerId'>{account.postcode ?? ''}</span>
                                                            </CustomerData>
                                                            <span className='tag'></span>
                                                            <span>{account.email ?? ''}</span>
                                                        </CustomerTab>
                                                    );
                                                }
                                            )
                                        }
                                    </td>
                                </TableRowAddColor>
                            )}
                        </tbody>
                    </InnerTable>
                </RowWithTable>
            </TableRow>
        );
    }

    render() {
        const { data, type } = this.props;
        const { rows } = this.state;

        const table = (
            <TableWrapper>
                <thead>
                    <TableHeaderRow>
                        <ColumnHeader></ColumnHeader>
                        <ColumnHeader>Date Detected</ColumnHeader>
                        <ColumnHeader>Payment details</ColumnHeader>
                        <ColumnHeader>Type</ColumnHeader>
                        <ColumnHeader>Expires</ColumnHeader>
                        <ColumnHeader>Number of Accounts</ColumnHeader>
                        <ColumnHeader>Post Code</ColumnHeader>
                        <ColumnHeader>Email</ColumnHeader>
                        <ColumnHeader>Action</ColumnHeader>
                    </TableHeaderRow>
                </thead>
                <tbody>
                    {data.map(d => this.renderRow(d, rows, type)).toArray()}
                </tbody>
            </TableWrapper>
        );

        return (
            <div>{table}</div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default MatchedPaymentMethods;
